import { render, staticRenderFns } from "./ExpertYearAssessAdd.vue?vue&type=template&id=1a36ac8d&scoped=true"
import script from "./ExpertYearAssessAdd.vue?vue&type=script&lang=js"
export * from "./ExpertYearAssessAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36ac8d",
  null
  
)

export default component.exports